"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshTokenResponseGuard = void 0;
var tslib_1 = require("tslib");
var token_data_extractor_1 = require("../../utils/token-data-extractor");
var user_data_response_validator_1 = require("../../utils/user-data-response-validator");
var refreshTokenResponseGuard = function (oldRefreshToken) { return function (response) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var oldTokenDeviceId, newTokenDeviceId, hasRequiredData, validationCallback;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, token_data_extractor_1.tokenDataExtractor.extractRefreshTokenDeviceId(oldRefreshToken)];
            case 1:
                oldTokenDeviceId = _a.sent();
                return [4 /*yield*/, token_data_extractor_1.tokenDataExtractor.extractRefreshTokenDeviceId(response.deviceRefreshToken)];
            case 2:
                newTokenDeviceId = _a.sent();
                hasRequiredData = Boolean(oldTokenDeviceId) && Boolean(newTokenDeviceId);
                if (!hasRequiredData) {
                    return [2 /*return*/, response];
                }
                validationCallback = function () { return oldTokenDeviceId === newTokenDeviceId; };
                return [2 /*return*/, user_data_response_validator_1.userDataResponseValidator.validateResponse({
                        response: response,
                        validationCallback: validationCallback,
                        reportingData: {
                            endpointUri: "/accessToken/refresh",
                            message: "Refresh token response is invalid for ".concat(oldTokenDeviceId, " compared with remote ").concat(newTokenDeviceId),
                            requestData: "deviceId: ".concat(oldTokenDeviceId),
                            responseData: "deviceId: ".concat(newTokenDeviceId),
                        },
                    })];
        }
    });
}); }; };
exports.refreshTokenResponseGuard = refreshTokenResponseGuard;
